import { type ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { FieldError } from './FieldError';

// A compact control in a pill row turns danger on error; the pill's tooltip also
// carries the full message
export const PillField = ({
  id,
  error,
  className,
  children,
}: {
  id: string;
  error: string | undefined;
  className?: string;
  children: ReactNode;
}) => (
  <div title={error} className={cn('flex min-w-0', className)}>
    {children}
    <FieldError id={id} error={error} />
  </div>
);
